import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FiberConsumption from '../../../../components/FiberConsumption';
import { getFormatDate } from '../../../../utils/dataTransformation/dateConversions';
import './index.scss';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import Stopper from '../../../../components/Stopper';
import { managementEnvironment } from '../../../../utils/dataTransformation/environments';

const PhoneConsumptionPage: React.FC = () => {
    const { t } = useTranslation();
    const homeDisabled = managementEnvironment().VITE_STOPPER_HOME_DISABLED;

    const { trackingScreenView } = new TrackingEvents();
    const storage = localStorage.getItem('storage');
    let dataTab;
    if (storage) {
        const storageJson = JSON.parse(storage);
        dataTab = storageJson;
    }

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <div className='phoneConsumption-page'>
            <FiberConsumption
                dataTab={dataTab.dataTab}
                BillingCycleData={`${getFormatDate(dataTab.cycleStarts, 'DD/MM')} - ${getFormatDate(
                    dataTab.cycleEnds,
                    'DD/MM',
                )} `}
                closing={`${dataTab.cycleEndInDays} ` + t('day')}
            ></FiberConsumption>
        </div>
    );
};

export default PhoneConsumptionPage;
